import { Component, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DeliberaService } from '../../services/delibera.service';
import { CheckProgressiviDto, TipoDelibera } from '../../model/delibere-data';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../environment/environment';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-dialog-delibera',
  templateUrl: './dialog-delibera.component.html',
  styleUrl: './dialog-delibera.component.scss'
})
export class DialogDeliberaComponent implements OnInit{
  private dialog_config = inject(DynamicDialogConfig);
  private dialog_ref = inject(DynamicDialogRef);
  private delibera_service = inject(DeliberaService);

  statoProgressivoCheck = {libero: 'LIBERO', progressivo: 'PROGRESSIVO', bloccato: 'BLOCCATO'};

  checkProgressivo: boolean = true;
  checkProgressivoColor: string | undefined;
  confermaOperazioneProgressivo: string | undefined;

  dataFinalizzazione: Date = new Date();

  // regione corrente
  gestioneDomande = environment.gestioneDomande;

  //spinner del bottone di invio
  isLoadingSpinner = false;

  //dati liste
  tipiDelibera: TipoDelibera[] = [];
  tipiDeliberaForm = new FormGroup({
    numeroDelibera: new FormControl<number|null>(null, Validators.required),
    tipo: new FormControl<TipoDelibera|null>(null, Validators.required),
    dataDelibera: new FormControl<Date|null>(null, Validators.required)
  });

  // dati delibera corrente
  numeroDeliberaMostrato: number | undefined;
  idDelibera: number|undefined;
  operazione: string | undefined;
  tipo: string | undefined;
  codiceDelibera: string | undefined;
  corpoDialog: string | undefined;
  controlloProgressivoDialog: string | undefined;
  labelBottone: string | undefined;

  ngOnInit(): void {
    this.operazione = this.dialog_config.data.operazione;
    this.tipo = this.dialog_config.data.tipo;
    this.codiceDelibera = this.generaCodiceDelibera();
    this.handleTipo();
  }

  //chiude il dialog e invia approvazione delibera corrente
  bottoneDelibera(){
    this.isLoadingSpinner = true;
    if(this.operazione === 'Approva')
      this.approvazioneDeliberaClose();
    if(this.operazione === 'Nuova')
      this.generazioneDelibera();
    if(this.operazione === 'Compila')
      this.compilaDeliberaClose();
    if(this.operazione === 'Modifica')
      this.modificaDeliberaCorrenteClose();
    if(this.operazione === 'Cancella')
      this.cancellazioneDeliberaClose();
  }

  //gestisce il tipo di delibera o dialog
  handleTipo(){
    if(this.operazione === 'Approva'){
      this.idDelibera = this.dialog_config.data.id;
      this.corpoDialog = 'Confermi di voler approvare il riepilogo corrente?';
      this.numeroDeliberaMostrato = this.dialog_config.data.numeroDelibera;
      this.dataFinalizzazione = new Date(this.dialog_config.data.dataDelibera);
      this.labelBottone = 'Approva Riepilogo';
    }
    if(this.operazione === 'Compila'){
      this.idDelibera = this.dialog_config.data.id;
      this.corpoDialog = 'Confermi di voler compilare il riepilogo corrente?';
      this.numeroDeliberaMostrato = this.dialog_config.data.numeroDelibera;
      this.labelBottone = 'Compila Riepilogo';
    }
    if(this.operazione === 'Modifica'){
      this.idDelibera = this.dialog_config.data.id;
      this.checkProgressiviHandler();
      this.corpoDialog = 'Modificando il seguente riepilogo, sarà necessario effettuata una nuova stampa.';
      this.numeroDeliberaMostrato = this.dialog_config.data.numeroDelibera;
      this.labelBottone = 'Modifica Riepilogo';
    }
    if(this.operazione === 'Cancella'){
      this.idDelibera = this.dialog_config.data.id;
      this.checkProgressiviHandler();
      this.corpoDialog = 'Confermi di voler cancellare il riepilogo corrente?';
      this.numeroDeliberaMostrato = this.dialog_config.data.numeroDelibera;
      this.labelBottone = 'Cancella Riepilogo';
    }
    if(this.operazione === 'Nuova'){
      this.labelBottone = 'Genera Riepilogo';
      this.delibera_service.ultimoNumeroDelibera().subscribe({
        next: ultimoNumero => {
          this.corpoDialog = 'Il nuovo riepilogo avrà il seguente numero';
          this.numeroDeliberaMostrato = ultimoNumero + 1;
        },
        error: (e) => {
          this.corpoDialog = 'Errore del server. Impossibile Procedere!'
        }
      })
      this.delibera_service.getTipiDelibera().subscribe(result => this.tipiDelibera = result);
    }
  }

  //chiusura dialog con stampa delibera
  compilaDeliberaClose(){
    this.delibera_service.stampaDeliberaCorrente(this.idDelibera!).subscribe({
      next: (result) => {
        this.dialog_ref.close(
          {
            delibera: result,
            esito: true
          }
        );
      },
      error: (e) => {
        this.dialog_ref.close({esito: false});
      }
    })
  }

  //chiusura dialog con approvazione delibera
  approvazioneDeliberaClose(){
    const dataFin = formatDate(this.dataFinalizzazione, "yyy-MM-dd", "en");
    this.delibera_service.approvaDeliberaCorrente(this.idDelibera!, dataFin).subscribe({
      next: (result) => {
        this.dialog_ref.close(
          {
            messaggio: result,
            esito: true
          }
        );
      },
      error: (e) => {
        this.dialog_ref.close({esito: false});
      }
    })
  }

  //chiusura dialog con generazione nuova delibera
  generazioneDelibera(){
    const tdf = this.tipiDeliberaForm.value;
    const dataDelibera = formatDate(tdf.dataDelibera!!, "yyy-MM-dd", "en");

    this.delibera_service.generaDelibera(tdf.numeroDelibera!, tdf.tipo?.codice!, dataDelibera).subscribe({
      next: (result) => {
        this.dialog_ref.close(
          {
            delibera: result,
            esito: true
          }
        );
      },
      error: (e) => {
        this.dialog_ref.close({errore: e, esito: false});
      }
    })
  }

  //chiusura dialog con abilitazione a modifica delibera
  modificaDeliberaCorrenteClose(){
    this.delibera_service.modificaDeliberaCorrente(this.idDelibera!, this.confermaOperazioneProgressivo!).subscribe({
      next: (result) => {
        this.dialog_ref.close(
          {
            delibera: result,
            esito: true
          }
        );
      },
      error: (e) => {
        this.dialog_ref.close({esito: false});
      }
    })
  }

  //chiusura dialog con cancellazione delibera
  cancellazioneDeliberaClose(){
    this.delibera_service.cancellaDelibera(this.idDelibera!, this.confermaOperazioneProgressivo!).subscribe({
      complete: () => {
        this.dialog_ref.close({esito: true});
      },
      error: (e) => {
        this.dialog_ref.close({esito: false});
      }
    })
  }

  //genera codice delibera
  generaCodiceDelibera(){
    let codice = '';

    if(this.tipo === 'provvisori_a') codice = 'A';
    if(this.tipo === 'provvisori_b') codice = 'B';

    return codice;
  }

  //gestione disable del bottono di immissione
  disableSubmitHandler(){
    if((this.operazione === 'Nuova' && (this.tipiDeliberaForm.pristine || this.tipiDeliberaForm.invalid))
      || (['Modifica', 'Cancella'].includes(this.operazione!) && this.checkProgressivo)){
      return true
    }
    return false;
  }

  private checkProgressiviHandler(){
    this.delibera_service.getCheckProgressivoProtocollo(this.idDelibera!).subscribe({
      next: (result: CheckProgressiviDto) => {
        switch(result.result){
          case this.statoProgressivoCheck.libero:
            this.checkProgressivoColor = '#16A34A';
            this.controlloProgressivoDialog = result.responseText;
            this.confermaOperazioneProgressivo = this.statoProgressivoCheck.libero;
            this.checkProgressivo = false;
            break;
          case this.statoProgressivoCheck.progressivo:
            this.checkProgressivoColor = '#FBA465';
            this.controlloProgressivoDialog = result.responseText;
            this.confermaOperazioneProgressivo = this.statoProgressivoCheck.progressivo;
            this.checkProgressivo = false;
            break;
          case this.statoProgressivoCheck.bloccato:
            this.checkProgressivoColor = '#EF5233';
            this.controlloProgressivoDialog = result.responseText;
            this.confermaOperazioneProgressivo = this.statoProgressivoCheck.bloccato;
            break;
          default:
            break;
        }
      }
    });
  }

  buildDate(data_in: Date){
    const day = String(data_in.getDate()).padStart(2, '0');
    const month = String(data_in.getMonth() + 1).padStart(2, '0');
    const year = String(data_in.getFullYear());
    return `${year}-${month}-${day}`;
  }
}